"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupPaymentMethods = void 0;
const groupBy_1 = __importDefault(require("lodash/groupBy"));
const isNumber_1 = __importDefault(require("lodash/isNumber"));
const groupPaymentMethods = ({ methods, methodGroups, }) => {
    // we leave only those methods where there are group_id as Number and method is enabled
    const filteredMethods = methods.filter((method) => (0, isNumber_1.default)(method.group_id) && method.enabled);
    const groupedMethods = (0, groupBy_1.default)(filteredMethods, 'group_id');
    // we leave only those groups where there are methods for this groups
    return methodGroups
        .map((group) => {
        var _a;
        return ({
            ...group,
            methods: (_a = groupedMethods[group.id]) !== null && _a !== void 0 ? _a : [],
        });
    })
        .filter((group) => group.methods.length);
};
exports.groupPaymentMethods = groupPaymentMethods;
//# sourceMappingURL=index.js.map